'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../../base/utils');

var _playback = require('../../base/playback');

var _playback2 = _interopRequireDefault(_playback);

var _template = require('../../base/template');

var _template2 = _interopRequireDefault(_template);

var _events = require('../../base/events');

var _events2 = _interopRequireDefault(_events);

var _error = require('./public/error.html');

var _error2 = _interopRequireDefault(_error);

require('./public/style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoOp = function (_Playback) {
  (0, _inherits3.default)(NoOp, _Playback);
  (0, _createClass3.default)(NoOp, [{
    key: 'name',
    get: function get() {
      return 'no_op';
    }
  }, {
    key: 'template',
    get: function get() {
      return (0, _template2.default)(_error2.default);
    }
  }, {
    key: 'attributes',
    get: function get() {
      return { 'data-no-op': '' };
    }
  }]);

  function NoOp() {
    var _ref;

    (0, _classCallCheck3.default)(this, NoOp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = NoOp.__proto__ || (0, _getPrototypeOf2.default)(NoOp)).call.apply(_ref, [this].concat(args)));

    _this._noiseFrameNum = -1;
    return _this;
  }

  (0, _createClass3.default)(NoOp, [{
    key: 'render',
    value: function render() {
      var playbackNotSupported = this.options.playbackNotSupportedMessage || this.i18n.t('playback_not_supported');
      this.$el.html(this.template({ message: playbackNotSupported }));
      this.trigger(_events2.default.PLAYBACK_READY, this.name);
      var showForNoOp = !!(this.options.poster && this.options.poster.showForNoOp);
      if (this.options.autoPlay || !showForNoOp) this._animate();

      return this;
    }
  }, {
    key: '_noise',
    value: function _noise() {
      this._noiseFrameNum = (this._noiseFrameNum + 1) % 5;
      if (this._noiseFrameNum) {
        // only update noise every 5 frames to save cpu
        return;
      }

      var idata = this.context.createImageData(this.context.canvas.width, this.context.canvas.height);
      var buffer32 = void 0;
      try {
        buffer32 = new Uint32Array(idata.data.buffer);
      } catch (err) {
        buffer32 = new Uint32Array(this.context.canvas.width * this.context.canvas.height * 4);
        var data = idata.data;
        for (var i = 0; i < data.length; i++) {
          buffer32[i] = data[i];
        }
      }

      var len = buffer32.length,
          m = Math.random() * 6 + 4;
      var run = 0,
          color = 0;
      for (var _i = 0; _i < len;) {
        if (run < 0) {
          run = m * Math.random();
          var p = Math.pow(Math.random(), 0.4);
          color = 255 * p << 24;
        }
        run -= 1;
        buffer32[_i++] = color;
      }
      this.context.putImageData(idata, 0, 0);
    }
  }, {
    key: '_loop',
    value: function _loop() {
      var _this2 = this;

      if (this._stop) return;

      this._noise();
      this._animationHandle = (0, _utils.requestAnimationFrame)(function () {
        return _this2._loop();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._animationHandle) {
        (0, _utils.cancelAnimationFrame)(this._animationHandle);
        this._stop = true;
      }
    }
  }, {
    key: '_animate',
    value: function _animate() {
      this.canvas = this.$el.find('canvas[data-no-op-canvas]')[0];
      this.context = this.canvas.getContext('2d');
      this._loop();
    }
  }]);
  return NoOp;
}(_playback2.default);

exports.default = NoOp;


NoOp.canPlay = function (source) {
  // eslint-disable-line no-unused-vars
  return true;
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/playbacks/no_op/no_op.js
// module id = 273
// module chunks = 0